import { gql } from '@apollo/client';

const SEND_CONTACT_FORM_MESSAGE_MUTATION = gql`
  mutation SendContactFormMessageMutation(
    $name: String!
    $email: String!
    $message: String!
  ) {
    sendContactFormMessage(name: $name, email: $email, message: $message)
  }
`;

export default SEND_CONTACT_FORM_MESSAGE_MUTATION;
